import { NOTE_CARD_PALETTE } from "@src/common/constants";

/** Default accent when a desktop profile has no synced presence color. */
export const DEFAULT_DESKTOP_PROFILE_COLOR = NOTE_CARD_PALETTE[0];
